import { call, put, takeLatest } from 'redux-saga/effects';
import { login, register, verifyEmail, setupCompany } from '@/api/auth';
import { 
  loginRequest, 
  loginSuccess, 
  loginFailure,
  registerRequest,
  registerSuccess,
  registerFailure,
  verifyRequest,
  verifySuccess,
  verifyFailure,
  setupCompanyRequest,
  setupCompanySuccess,
  setupCompanyFailure,
} from '../slices/authSlice';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { UserData, Company, LoginResponse } from '@/types/auth';
import type { ApiError } from '@/api/auth';

function* handleLogin(action: PayloadAction<{ user_id: string; password: string }>) {
  try {
    const response: LoginResponse = yield call(login, action.payload);
    yield put(loginSuccess(response));
  } catch (error) {
    yield put(loginFailure(error as ApiError));
  }
}

function* handleRegister(action: PayloadAction<UserData>) {
  try {
    const response = yield call(register, action.payload);
    yield put(registerSuccess(response));
  } catch (error) {
    yield put(registerFailure(error as ApiError));
  }
}

function* handleVerify(action: PayloadAction<string>) {
  try {
    yield call(verifyEmail, action.payload);
    yield put(verifySuccess());
  } catch (error) {
    yield put(verifyFailure(error as ApiError));
  }
}

function* handleSetupCompany(action: PayloadAction<Company>) {
  try {
    const response = yield call(setupCompany, action.payload);
    yield put(setupCompanySuccess(response));
  } catch (error) {
    yield put(setupCompanyFailure(error as ApiError));
  }
}

export function* watchAuthSagas() {
  yield takeLatest(loginRequest.type, handleLogin);
  yield takeLatest(registerRequest.type, handleRegister);
  yield takeLatest(verifyRequest.type, handleVerify);
  yield takeLatest(setupCompanyRequest.type, handleSetupCompany);
}